import { Breadcrumbs, MetaSeo, ProdottiListing } from '../../components/index'
import { CATEGORIE, CATEGORIESLUGTREE, LISTING, PAGINEDETAIL } from '../../utils/endpoint'
import {
  addCategoria,
  addCategorie,
  clearCategorie,
  removeCategoria,
} from '../../containers/categorie'
import { useEffect, useState, useContext } from 'react'
const queryString = require('query-string')
import Error from 'next/error'
import { api } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import NewCategorieListing from '../../components/molecules/NewCategorieListing/NewCategorieListing'
import { ListingContext } from '../../context/ListingContext'
import CatalogoBrandHome from '../../components/molecules/CatalogoBrandHome/CatalogoBrandHome'
import BrandListingHeader from '../../components/organisms/BrandListingHeader/BrandListingHeader'
import CategorieListingMobile from '../../components/organisms/CategorieListingMobile/CategorieListingMobile'
import { isBrandLayout } from '../../utils/brand'

const CategorieDetail = ({ page, statusCode, actual_categoria, categorie_list }) => {
  if (!page) return <Error statusCode={statusCode} />
  const router = useRouter()
  const { showFilters, setShowFilters } = useContext(ListingContext)
  const [current, SetCurrent] = useState(actual_categoria)
  const [listingPage, setPage] = useState(parseInt(router?.query.page) || 1)
  const [search, setSearch] = useState(null)
  const [trend, setTrend] = useState(null)
  const [ordinamento, setOrdinamento] = useState(router?.query.o || null)
  const { categorie } = useSelector((state) => state.categorie)
  const { service_gift } = useSelector((state) => state?.servicegift)
  const [currentSubCategoria, setCurrentSubCategoria] = useState(null)

  const dispatch = useDispatch()
  const listingProps = {
    model: 'prodotto',
    url: LISTING,
    actual_categoria,
    elemento: { filtri_initial: trend },
    categorie_list,
    trend,
    categorie: categorie,
    listingPage,
    search,
    ord: ordinamento,
  }
  useEffect(() => {
    let parsed = queryString.parseUrl(router.asPath)
    dispatch(clearCategorie())
    SetCurrent(actual_categoria)
    HandleIds(parsed.query['ids'])
    dispatch(addCategoria(actual_categoria))
    HandlePagination(parsed.query['page'])
    HandleSearch(parsed.query['search'])
    HandleTrend(parsed.query['trend'])
    HandleOrdinamento(parsed.query['o'])
  }, [])

  useEffect(() => {
    let parsed = queryString.parseUrl(router.asPath)
    SetCurrent(actual_categoria)
    dispatch(clearCategorie())
    dispatch(addCategoria(actual_categoria))
    HandleIds(parsed.query['ids'])
    HandlePagination(parsed.query['page'])
    HandleSearch(parsed.query['search'])
    HandleTrend(parsed.query['trend'])
    HandleOrdinamento(parsed.query['o'])
  }, [actual_categoria])

  useEffect(() => {
    HandleSubCategoria()
  }, [categorie])

  const HandleSubCategoria = () => {
    const cat = categorie_list.filter((item) => isBrandLayout(item))
    if (cat.length > 0) {
      let isBrand = categorie.includes(cat[0].id) // check se la categoria corrente è un brand
      if (!isBrand) {
        isBrand = cat[0].children.filter((item) => item.id === categorie[0]).length > 0 // check se la categoria corrente è un sotto brand
      }
      if (isBrand) {
        const categorie_not_brands = categorie.filter((c) => c != cat[0].id)
        if (cat[0].children && cat[0].children.length > 0) {
          const brand_slides_children = cat[0].children.filter((c) =>
            categorie_not_brands.includes(c.id)
          )
          if (brand_slides_children.length > 0) {
            setCurrentSubCategoria(brand_slides_children[0])
          }
        }
      } else {
        setCurrentSubCategoria(null)
      }
    }
    if (categorie.length > 2) {
      setCurrentSubCategoria(null)
    }
  }

  const HandleOrdinamento = (o) => {
    o && setOrdinamento(o)
  }

  const HandleTrend = (trend) => {
    trend && setTrend(trend)
  }

  const HandleSearch = (search) => {
    search && setSearch(search)
  }

  const HandlePagination = (p) => {
    if (!p) {
      setPage(1)
      return
    }
    let pa = parseInt(p)
    Number.isInteger(pa) && setPage(pa)
  }

  const HandleIds = (ids) => {
    if (!ids) {
      return
    }
    let convertedArray = []
    if (Array.isArray(ids)) {
      ids.map((item) => !convertedArray.includes(Number(item)) && convertedArray.push(Number(item)))
    } else {
      !convertedArray.includes(Number(ids)) && convertedArray.push(Number(ids))
    }
    //!convertedArray.includes(actual_categoria) && convertedArray.push(actual_categoria)
    dispatch(addCategorie(convertedArray))
  }

  const HandleRemove = (unchecked, current = null, new_element = null) => {
    let subcat = []
    if (current && new_element) {
      subcat = categorie
        .filter((element) => element != unchecked.id)
        .filter((element) => element != current)
        .filter((element) => element != new_element.id)
    } else {
      current
        ? (subcat = categorie
            .filter((element) => element != unchecked.id)
            .filter((element) => element != current))
        : (subcat = categorie.filter((element) => element != unchecked.id))
    }
    var esc = encodeURIComponent
    var query = subcat.length > 1 ? subcat.map((value) => 'ids[]' + '=' + esc(value)).join('&') : ''
    if (categorie.length == 1) {
      dispatch(removeCategoria(unchecked.id))
      dispatch(addCategoria(new_element.id))
      router.push(new_element.url, undefined, { shallow: true })
    } else {
      dispatch(removeCategoria(unchecked.id))
    }
    return query
  }

  const HandleRouting = (active, item) => {
    if (!active) {
      dispatch(addCategoria(item.id))
      return
    } else {
      //caso in cui sia l'unica selezionata
      if (categorie.length == 0) {
        return
      }
      if (item.id == current) {
        if (categorie.length == 1) {
          let padre = categorie_list.filter(
            (el) => el.children.filter((element) => element.id == item.id).length > 0
          )
          HandleRemove(item, current, padre[0])
        } else {
          let new_element_id = categorie.filter((item) => item != current)[0]
          let new_element = categorie_list.filter((item) => item.id == new_element_id)[0]
          !new_element &&
            (new_element = categorie_list
              .filter(
                (item) => item.children.filter((element) => element.id == new_element_id).length > 0
              )
              .map((item) => item.children.filter((child) => child.id == new_element_id)[0])[0])
          HandleRemove(item, current, new_element)
        }
        return
      } else {
        //caso in cui non sia l'unica selezionata
        HandleRemove(item)
      }
    }
  }

  const GetNomeCategoria = () => {
    let nome = ''
    categorie_list.filter((item) => item.id == actual_categoria).length > 0 &&
      (nome = categorie_list.filter((item) => item.id == actual_categoria)[0].nome)
    if (nome != '') {
      return nome
    }
    categorie_list.forEach((item) =>
      item.children.forEach((children) => children.id == actual_categoria && (nome = children.nome))
    )
    return nome
  }

  const isBrandSelected = () => {
    const cat = categorie_list.filter((item) => isBrandLayout(item))
    const catListing = cat.length > 0 ? categorie.includes(cat[0].id) : false
    let isBrandSelected = catListing && categorie.length == 1 && cat.length
    return isBrandSelected
  }

  // PER SG NON INDICIZZO PRODOTTI
  if (service_gift) {
    page.seo.noindex = true
  }

  return (
    <>
      <MetaSeo seo={page.seo} />
      <main className="page categoria-detail">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          <h1 className="page__title">{GetNomeCategoria()}</h1>

          <div className="row">
            <div className="col-12 col-lg-3">
              <CategorieListingMobile
                placeholder={actual_categoria?.nome}
                openFilters={() => setShowFilters(!showFilters)}
              >
                <NewCategorieListing
                  categorie_list={categorie_list}
                  current={current}
                  categorie={categorie}
                  HandleRouting={HandleRouting}
                ></NewCategorieListing>
              </CategorieListingMobile>
            </div>
            {listingProps && isBrandSelected() ? (
              <div className="col-12 col-lg-9">
                <div className="row">
                  {listingProps?.categorie_list
                    ?.find((item) => isBrandLayout(item))
                    ?.children?.filter((c) => c?.brand_banner?.image)
                    .map((c, k) => (
                      <div className="col-lg-4">
                        <CatalogoBrandHome
                          img={c.brand_banner.image}
                          brand_image={c.brand_banner.brand_image}
                          title={c.titolo}
                          url={c.url}
                        />
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              listingProps && (
                <div className="col-12 col-lg-9">
                  {currentSubCategoria ? (
                    <BrandListingHeader categoria={currentSubCategoria} />
                  ) : null}
                  <ProdottiListing {...listingProps} />
                </div>
              )
            )}
          </div>
        </div>
      </main>
    </>
  )
}
export async function getServerSideProps({ params, locale, res }) {
  let slug = params.slug
  if (params.slug.length > 1) {
    slug = params.slug.join('|')
  }
  try {
    const response = await api.get(`${CATEGORIESLUGTREE}${slug}/`, { params: { lang: locale } })
    const d = await response.data
    res.setHeader('Cache-Control', 's-maxage=43200, stale-while-revalidate')

    const redirect = d?.redirect
    if (redirect) {
      res.setHeader('location', redirect)
      res.statusCode = 301
      res.end()
      return { props: {} }
    }

    const actual_categoria = d.id
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'categoria-detail',
        lang: locale,
        content_type_id: d.model,
        object_id: d.id,
      },
    })
    const page = pageResponse.data
    const categorie = await api.get(CATEGORIE, { params: { lang: locale } })
    const categorie_list = await categorie.data

    return {
      props: { page, actual_categoria, categorie_list },
    }
  } catch (error) {
    res.statusCode = 404
    return { props: { statusCode: 404 } }
  }
}

export default CategorieDetail
